const BookingSourceCivitatis = 'Civitatis'; 

export function getActivityTypeLabelKey(type: string): string {
  return ACTIVITY_TYPE_TITLES?.[type] ?? type;
}

export function isAnValidActivitySource(source: string): boolean {
  return source === BookingSourceCivitatis;
}

const ACTIVITY_TYPE_TITLES = {
  Adventure: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.ADVENTURE',
  CruiseAndWaterActivities: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.CRUISE_AND_WATER_ACTIVITIES',
  Dining: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.DINING',
  ShowAndEventTickets: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.SHOW_AND_EVENT_TICKETS',
  Golf: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.GOLF',
  Transfers: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.TRANSFERS',
  OtherServices: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.OTHER_SERVICES',
  Shopping: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.SHOPPING',
  Spa: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.SPA',
  ToursAndActivities: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.TOURS_AND_ACTIVITIES',
  ThemeParksAndAttractions: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.THEME_PARKS_AND_ATTRACTIONS',
  Wedding: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.WEDDING',
  GolfActivities: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.GOLF_ACTIVITIES',
  AirExtras: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.AIR_EXTRAS',
  CreditCardCharge: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.CREDIT_CARD_CHARGE',
  SkiActivities: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.SKI_ACTIVITIES',
  SkiLiftTickets: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.SKI_LIFT_TICKETS',
  Train: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.TRAIN',
  TravelInsurance: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.TRAVEL_INSURANCE',
  Visa: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.VISA',
  Bus: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.BUS',
  DinnerShow: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.DINNER_SHOW',
  CityTour: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.CITY_TOUR',
  Meal: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.MEAL',
  Interview: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.INTERVIEW',
  Show: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.SHOW',
  Lunch: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.LUNCH',
  AirTransfer: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.AIR_TRANSFER',
  Course: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.COURSE',
  Camping: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.CAMPING',
  Package: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.PACKAGE',
  Farm: 'TOUR_AND_ACTIVITIES_MODULE.ACTIVITY_TYPE.FARM'
};
